module.exports = __webpack_public_path__ + "img/fondoCoche2.5c2e253c.gif";